import { Link } from 'react-router-dom'
import { Menu, X } from 'lucide-react'
import { useAuthStore } from '../../store/authStore'
import DashIcon from '../ui/DashIcon'
import DashAvatar from '../ui/DashAvatar'
import { NotificationBell } from '../shared/NotificationBell'

interface TopBarProps {
  sidebarOpen: boolean
  onToggleSidebar: () => void
}

export default function TopBar({ sidebarOpen, onToggleSidebar }: TopBarProps) {
  const { user } = useAuthStore()

  const roleLabel: Record<string, string> = {
    admin: 'Operations Admin',
    expediteur: 'Expéditeur',
    livreur: 'Livreur',
  }

  return (
    <header className="topbar">
      <button
        type="button"
        className="topbar-menu-btn"
        onClick={onToggleSidebar}
        aria-label={sidebarOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
        aria-expanded={sidebarOpen}
        aria-controls="app-sidebar"
      >
        {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
      </button>
      <div className="topbar-search">
        <DashIcon name="search" size={16} />
        <input placeholder="Rechercher commandes, livreurs, clients…" />
        <span className="kbd">⌘K</span>
      </div>
      <div className="topbar-spacer" />
      <Link to="/" className="topbar-icon-btn" title="Retour à l'accueil" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <DashIcon name="home" />
      </Link>
      <NotificationBell triggerClassName="topbar-icon-btn" />
      <button className="topbar-icon-btn" title="Aide">
        <DashIcon name="globe" />
      </button>
      {user && (
        <div className="topbar-user">
          <DashAvatar name={user.name} size={28} />
          <div>
            <b>{user.name}</b>
            <span>{roleLabel[user.role] ?? user.role}</span>
          </div>
        </div>
      )}
    </header>
  )
}
